class EchoNode{

    constructor(context){
        this.context=context;
        this.input=this.context.createGain();
        this.delay=this.context.createDelay(10);
        this.delayGain=this.context.createGain();
        this.feedbackGain=this.context.createGain();
        this.outputGain=this.context.createGain();
        this.input.connect(this.delay);
        this.input.connect(this.outputGain);
        this.delay.connect(this.feedbackGain);
        this.feedbackGain.connect(this.delay);
        this.delay.connect(this.delayGain);
        this.delayGain.connect(this.outputGain);
    }

    connect(output){
        this.outputGain.connect(output);
    }

    disconnect(output){
        this.outputGain.disconnect();
    }

    setParam=(key,value)=>{
        if(key==="MIX"){
            this.delayGain.gain.setValueAtTime(value,this.context.currentTime);
            return;
        }
        if(key=="FDBK"){
            this.feedbackGain.gain.setValueAtTime(value,this.context.currentTime);
            return;
        }
        if(key=="TIME"){
            this.delay.delayTime.setValueAtTime(value,this.context.currentTime);
            return;
        }
        
        throw new Error(`unkown parameter ${key}`);

    }

}

export default EchoNode;